import axios from 'axios';
import { baseURL, mpc } from '../Constants/APIUrls';

export const getCountryListService = async () => {
	try {
		const token = localStorage.getItem('AccessToken');
		const axiosInstance = axios.create({
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		const response = await axiosInstance.get(
			`${baseURL}${mpc.getAllCountries}`
		);
		const results = response ? response.data : [];
		return results;
	} catch (err) {
		console.error(err);
		throw new Error(err);
	}
};

export const getAllCountryListService = async () => {
	try {
		const token = localStorage.getItem('AccessToken');
		const axiosInstance = axios.create({
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		const response = await axiosInstance.get(
			`${baseURL}${mpc.getAllCountriesIsoInternational}`
		);
		const results = response ? response.data : [];
		return results;
	} catch (err) {
		console.error(err);
		throw new Error(err);
	}
};
